import React from "react";
import { withRouter, Redirect } from "react-router";
import LogUtil from "./util/LogUtil";
import NavegadorUtil from "./util/NavegadorUtil";
import { Link } from "react-router-dom";

class Capa extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  componentDidMount(): any {
    setTimeout(() => {
      this.setState({ redirect: true });
    }, 20);
    LogUtil.logPage("Capa");
  }

  render(): any {
    if (this.state.redirect) {
      return <Redirect to="/lojas"></Redirect>;
    }

    return (
      <section className="capa">
        <Link to={NavegadorUtil.getUrl("/lojas")}>
          <img
            src="assets/images/icons/img-logo-new.svg"
            alt="Oba Hortifruti"
            className="welcome"
          />
        </Link>
      </section>
    );
  }
}

export default withRouter(Capa);
